export const endpointNameList = "checkList";
export const endpointNameItems = "checkItems";